module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iNSIgdmlld0JveD0iMCAwIDEyIDUiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02IDVMMC44MDM4NDcgMC41TDExLjE5NjIgMC41MDAwMDFMNiA1WiIgZmlsbD0iIzMyNDQ2NyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/down-arrow-full.svg
// module id = Glgf
// module chunks = 1